import { Chip, Grid } from "@mui/material";
import React from "react";

const RecipeGallonOptionsGrid = () => {
  return (
    <Grid
      container
      justify="flex-end"
      direction="row"
      alignItems="center"
      justifyContent="center"
      className="sticky top-[190px] bg-[#e5e5e5]"
    >
      <Chip
        size="small"
        className="m-2"
        label={
          <span className="flex">
            <span >
              <img
                // className="rounded-full"
                style={{ width: "20px" }}
                src={"../assets/icons/recipe-card-icon.png"}
                alt="recipe"
              />
            </span>
            <span className="pl-1">: Recipe Card</span>
          </span>
        }
      />
    </Grid>
  );
};

export default RecipeGallonOptionsGrid;
